import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

window.addEventListener('unhandledrejection', (event) => {
  const msg = event.reason?.message ?? '';

  // Rechargement automatique si un chunk lazy est introuvable après un déploiement
  if (msg.includes('Failed to fetch dynamically imported module') ||
      msg.includes('Importing a module script failed')) {
    const reloadKey = 'chunk_reload_ts';
    const last = Number(sessionStorage.getItem(reloadKey) ?? 0);
    if (Date.now() - last > 10_000) {
      sessionStorage.setItem(reloadKey, String(Date.now()));
      window.location.reload();
    }
    return;
  }

  // Firebase Messaging tente de rafraîchir un token lié à un service worker
  // d'un ancien domaine (ex: mycopro-fb5fd.web.app) — la registration est
  // inaccessible depuis le domaine courant → pushManager est undefined.
  // On supprime l'erreur pour ne pas bloquer l'initialisation.
  if (msg.includes('pushManager')) {
    event.preventDefault();
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
